import PropTypes from 'prop-types'
import ButtonCta from '@components/atoms/button-cta'
import renderLink from '@components/renderers/render-link'
import ButtonLink from '@components/atoms/button-link'
import useStyles from '@components/leaderboard/leaderboard.style-hook'
import { safeHttpUrlForHref } from '@utils/validations'

/**
 * Stable, DOM-safe token from the link href so multiple leaderboard CTAs
 * on one page (e.g. embed vs tour leaderboard) have distinct data-testid suffixes.
 */
function leaderboardDestinationKey(href) {
  if (!href || typeof href !== 'string') return 'none'
  try {
    if (href.startsWith('/')) {
      const trimmed = href.replace(/^\/+|\/+$/g, '').replace(/\//g, '--')
      return trimmed || 'root'
    }
    const url = new URL(href)
    const host = url.hostname.replace(/^www\./, '').replace(/\./g, '-')
    const path = url.pathname.replace(/^\/+|\/+$/g, '').replace(/\//g, '--')
    return path ? `${host}--${path}` : host
  } catch {
    return 'unknown'
  }
}

function ButtonViewLeaderboard(props) {
  const {
    headline, slug, externalUrl, fullCoverageUrl,
  } = props
  const safeExternalUrl = safeHttpUrlForHref(externalUrl)
  const safeFullCoverageUrl = safeHttpUrlForHref(fullCoverageUrl)

  let viewUrl
  if (safeExternalUrl) {
    const url = new URL(safeExternalUrl)
    if (url.hostname === 'www.pga.com') {
      viewUrl = url.pathname || '/'
    }
  }

  if (!slug && !safeExternalUrl && !safeFullCoverageUrl) return null
  const linkProps = renderLink({ slug, type: 'Leaderboard' })

  const href = viewUrl || safeExternalUrl || safeFullCoverageUrl || linkProps.href
  const destinationKey = leaderboardDestinationKey(href)

  const styles = useStyles()
  return (
    <ButtonCta
      className={styles.leaderboardButton}
      component={ButtonLink}
      variant="contained"
      color="primary"
      size="small"
      align="center"
      href={href}
      dataAttrs={{
        'data-gtm-event-name': headline,
        'data-gtm-text': 'FULL LEADERBOARD',
        'data-testid': `view-full-leaderboard--${destinationKey}`,
      }}
    >
      View Full Leaderboard
    </ButtonCta>
  )
}

ButtonViewLeaderboard.propTypes = {
  headline: PropTypes.string,
  slug: PropTypes.string,
  externalUrl: PropTypes.string,
  fullCoverageUrl: PropTypes.string,
}

export default ButtonViewLeaderboard
